import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const DoughnutBar = ({ordensUFAtivas}) => {
  const data = {
    labels: ordensUFAtivas.map((item) => item.uf),
    datasets: [
      {
        label: "Ordens Ativas por UF",
        data: ordensUFAtivas.map((item) => item.total),
        backgroundColor: "#0361a7",
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Distribuição de Ordens Ativas por Estado (UF)",
      },
    },
  };

  return (
    <div style={{ alignItems: "center" }}>
      {/* Gráfico */}
      <div style={{ height: "60vh" }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default DoughnutBar;
